import { Pencil1Icon, TrashIcon } from "@radix-ui/react-icons";
import { useState } from "react";
import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { ConfirmAlertDialog } from "../../../components/common/ConfirmAlertDialog";
import { Lists } from "../../../components/common/Lists";
import TableComponent from "../../../components/common/Tables";
import { useAppDispatch } from "../../../hooks/hooks";
import { useGetEntitiesQuery } from "../../../hooks/scientific/useGetEntitiesQuery";
import { routes } from "../../../routes";
import { EntityType } from "../../../types/ScientificModule";
import { Key_entities } from "../../../utils/constants";
import { updateEntity } from "../../../services/scientific/entity";
import { setEntitiesData } from "../../../redux/slices/scientific/entities";

const columnNamesMap: { [key: string]: string } = {
  description: "Descrição",
  country: "País",
};

export const Entities = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const queryClient = useQueryClient();
  const { data, status } = useGetEntitiesQuery({ PageNumber: currentPage, PageSize: 400 });
  const [deleteItem, setDeleteItem] = useState<EntityType | null>(null);

  const mutationUpdate = useMutation(updateEntity, {
    onSuccess: () => {
      queryClient.invalidateQueries(Key_entities);
      toast.success("Entidade atualizada com sucesso!");
    },
    onError: () => {
      toast.error("Erro ao atualizar a Entidade.");
    },
  });

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const handleClickCreate = () => {
    navigate(routes.createEntity);
  };

  const handleEdit = (entity: EntityType) => {
    dispatch(setEntitiesData(entity));
    navigate(routes.updateEntity);
  };

  const handleDelete = (entity: EntityType) => {
    entity.status = false;
    mutationUpdate.mutateAsync(entity);
  };

  const openDeleteDialog = (entity: EntityType) => {
    setDeleteItem(entity);
  };

  const confirmDelete = async () => {
    if (deleteItem) {
      await handleDelete(deleteItem);
    }
  };

  const options = data?.items.map((entity: EntityType) => [
    {
      label: "Editar",
      onClick: () => handleEdit(entity),
      icon: <Pencil1Icon />,
    },
    {
      label: "Excluir",
      onClick: () => openDeleteDialog(entity),
      icon: <TrashIcon />,
    },
  ]) || [];

  return (
    <>
      <Lists
        status={status}
        TableComponent={() => (
          <TableComponent
            columns={Object.keys(columnNamesMap)}
            items={data?.items}
            options={options}
            columnNamesMap={columnNamesMap}
            totalPages={data?.totalPages || 1}
            currentPage={currentPage}
            onPageChange={handlePageChange}
          />
        )}
        handleClickCreate={handleClickCreate}
      />
      <ConfirmAlertDialog
        open={!!deleteItem}
        onOpenChange={(open) => !open && setDeleteItem(null)}
        title="Esta operação é irreversível"
        item={deleteItem}
        onConfirm={confirmDelete}
        onCancel={() => setDeleteItem(null)}
      />
    </>
  );
};
